"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestApiCaller = void 0;
// externals
var http_status_codes_1 = require("http-status-codes");
var STANDARD_HEADERS = {
    Accept: 'application/json',
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/json'
};
var RestApiCaller = /** @class */ (function () {
    function RestApiCaller() {
        var _this = this;
        this.setupApiCaller = function (apiCaller) {
            _this.apiCaller = apiCaller;
            if (!_this.isRestApiCallerValid()) {
                throw new Error("restApiCaller.setupApiCaller must be called with a valid apiCaller: \"".concat(_this.getRestApiCallerValidationMessage(), "\""));
            }
        };
        this.reset = function () {
            _this.apiCaller = undefined;
        };
        this.isRestApiCallerValid = function () { return !_this.getRestApiCallerValidationMessage(); };
        this.getRestApiCallerValidationMessage = function () {
            if (!_this.apiCaller) {
                return 'apiCaller provided is undefined';
            }
            if (!_this.apiCaller.call) {
                return 'apiCaller provided does not have a call function';
            }
            return undefined;
        };
        this.isConfigured = function () { return !_this.getConfigValidationMessage(); };
        this.getConfigValidationMessage = function () {
            if (!_this.apiCaller) {
                return 'restApiCaller.setupApiCaller needs to be called first';
            }
            return undefined;
        };
        this.getResource = function (resourceItemUri, overrides) { return __awaiter(_this, void 0, void 0, function () {
            var additionalOptions, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        additionalOptions = this.buildAdditionalOptions(overrides);
                        return [4 /*yield*/, this.callRestApi({
                                method: 'GET',
                                url: resourceItemUri,
                                headers: this.buildHeaders(overrides === null || overrides === void 0 ? void 0 : overrides.headers)
                            }, additionalOptions)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        }); };
        this.addResource = function (resourceCollectionUri, resource, overrides) { return __awaiter(_this, void 0, void 0, function () {
            var additionalOptions, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        additionalOptions = this.buildAdditionalOptions(overrides);
                        return [4 /*yield*/, this.callRestApi({
                                method: 'POST',
                                url: resourceCollectionUri,
                                headers: this.buildHeaders(overrides === null || overrides === void 0 ? void 0 : overrides.headers),
                                data: resource
                            }, additionalOptions)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        }); };
        /**
         * This uses the HTTP PUT verb to update a specified resource.  The URL should follow typical REST conventions for a resource
         * (for example, "/dealers/{dealerId}") or a collection (for example, "/dealers")
         * @param resourceItemUri resource URI (see example in description)
         * @param resource the resource to be updated
         * @returns typically this should return an updated copy of the resource.
         */
        this.updateResource = function (resourceItemUri, resource, overrides) { return __awaiter(_this, void 0, void 0, function () {
            var additionalOptions;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        additionalOptions = this.buildAdditionalOptions(overrides);
                        return [4 /*yield*/, this.callRestApi({
                                method: 'PUT',
                                url: resourceItemUri,
                                headers: this.buildHeaders(overrides === null || overrides === void 0 ? void 0 : overrides.headers),
                                data: resource
                            }, additionalOptions)];
                    case 1: return [2 /*return*/, (_a.sent())];
                }
            });
        }); };
        /**
         * This uses the HTTP DELETE verb to delete the specified resource.  The URL should follow typical REST conventions for a
         * resource (for example, "/dealers/{dealerId}").
         * @param resourceItemUri resource URI (see example in description)
         * @param resource the resource to be deleted
         */
        this.deleteResource = function (resourceItemUri, overrides) { return __awaiter(_this, void 0, void 0, function () {
            var additionalOptions;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        additionalOptions = this.buildAdditionalOptions(overrides);
                        return [4 /*yield*/, this.callRestApi({
                                method: 'DELETE',
                                url: resourceItemUri,
                                headers: this.buildHeaders(overrides === null || overrides === void 0 ? void 0 : overrides.headers)
                            }, additionalOptions)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        /**
         * This uses the HTTP POST verb to essentially perform a remote procedure call (rather than CRUD resource operations).
         * @param actionEndpoint "rpc" endpoint
         * @param actionArgsAsObject parameters (rather than a resource) provided to action being executed with POST
         * @returns results of "rpc" call.
         *
         * NOTE: The current implementation matches "addResource" but semantics matter, so remoteProcedureCall should be used
         *   when a "REST" API isn't truly restful.  If it is more of an RMM Level 1 API then remoteProcedureCall should be used
         *   to show intent of calling a "function" rather than adding a resource.
         */
        this.remoteProcedureCall = function (actionEndpoint, actionArgsAsObject, overrides) { return __awaiter(_this, void 0, void 0, function () {
            var additionalOptions, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        additionalOptions = this.buildAdditionalOptions(overrides);
                        return [4 /*yield*/, this.callRestApi({
                                method: 'POST',
                                url: actionEndpoint,
                                headers: this.buildHeaders(overrides === null || overrides === void 0 ? void 0 : overrides.headers),
                                data: actionArgsAsObject
                            }, additionalOptions)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        }); };
        this.callRestApi = function (options, additionalOptions) { return __awaiter(_this, void 0, void 0, function () {
            var response, result, err_1, errMsg;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!this.isConfigured()) {
                            throw new Error(this.getConfigValidationMessage());
                        }
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.apiCaller.call(options)];
                    case 2:
                        response = _e.sent();
                        result = {
                            ok: true,
                            statusCode: response.status,
                            response: response.data,
                            headers: response.headers
                        };
                        return [2 /*return*/, result];
                    case 3:
                        err_1 = _e.sent();
                        errMsg = "".concat(err_1);
                        if (((_a = additionalOptions === null || additionalOptions === void 0 ? void 0 : additionalOptions.throwExceptionsForStatuses) === null || _a === void 0 ? void 0 : _a['4xx']) && this.apiCaller.is4xxError(errMsg)) {
                            throw err_1;
                        }
                        if (((_b = additionalOptions === null || additionalOptions === void 0 ? void 0 : additionalOptions.throwExceptionsForStatuses) === null || _b === void 0 ? void 0 : _b['5xx']) && this.apiCaller.is5xxError(errMsg)) {
                            throw err_1;
                        }
                        return [2 /*return*/, {
                                ok: false,
                                statusCode: ((_c = err_1.response) === null || _c === void 0 ? void 0 : _c.status) || http_status_codes_1.StatusCodes.INTERNAL_SERVER_ERROR,
                                message: err_1.message,
                                rawError: err_1,
                                response: (_d = err_1.response) === null || _d === void 0 ? void 0 : _d.data
                            }];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.buildAdditionalOptions = function (overrides) {
            var _a, _b;
            if (((_a = overrides === null || overrides === void 0 ? void 0 : overrides.throwExceptionsForStatuses) === null || _a === void 0 ? void 0 : _a['4xx']) || ((_b = overrides === null || overrides === void 0 ? void 0 : overrides.throwExceptionsForStatuses) === null || _b === void 0 ? void 0 : _b['5xx'])) {
                return { throwExceptionsForStatuses: overrides.throwExceptionsForStatuses };
            }
            return undefined;
        };
        this.buildHeaders = function (headers) {
            return headers ? __assign(__assign({}, STANDARD_HEADERS), headers) : STANDARD_HEADERS;
        };
    }
    return RestApiCaller;
}());
exports.RestApiCaller = RestApiCaller;
var restApiCaller = new RestApiCaller();
exports.default = restApiCaller;
